define('modules/content_recommendations/collections/content_recommendations_collection',['backbone', 'jquery', '_', 'session'], function (
  Backbone,
  $,
  _,
  session
) {
  'use strict';
  var TemplatesCollection = Backbone.Collection.extend({
    params: {
      search: null,
      order_by: 'title',
      order: 'ASC',
      limit: 20,
      offset: 0,
      total: 0,
    },

    parse: function (response) {
      this.params.order_by = response.metadata.order_by || 'title';
      this.params.order = response.metadata.order || 'ASC';
      this.params.limit = response.metadata.limit || 20;
      this.params.offset = response.metadata.offset || 0;
      this.params.total = response.metadata.total || 0;

      return response.weeklyoffers;
    },

    url: function () {
      return session.get('apiUrl') + 'acrcampaigns/search';
    },
  });

  return new TemplatesCollection();
});

